import React from 'react';
import Loading from '../../../../Components/Loading';
import NCZILoadingStatus from '../NCZILoadingStatus/NCZILoadingStatus';
import NCZICommandError from '../NCZICommandError/NCZICommandError';

interface NCZICommandResultParams {
	commandId?: string;
	handleRetryCommand?: () => void;
}

const NCZICommandResult: React.FC<NCZICommandResultParams> = params => {
	const { commandId, handleRetryCommand } = params;

	if (!commandId) {
		return <Loading />;
	}

	return (
		<>
			<NCZILoadingStatus commandId={commandId} />
			<NCZICommandError
				commandId={commandId}
				handleRetry={handleRetryCommand}
			/>
		</>
	);
};

export default NCZICommandResult;
